export default class FormController {
	#fromView;

	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 * @param {any} $scope
	 */
	constructor(
		$location,
		$routeParams,
		$scope,
	) {
		this.kid = $routeParams.formId;

		this.#fromView = '/';

		this.$location = $location;
		this.$routeParams = $routeParams;
		this.$scope = $scope;

		/** @type {any} */
		const options = {};

		const search = $location.search();

		if ('from' in search) {
			this.#fromView = `/${search.from}`;
		}

		if (!this.kid) {
			this.#fromView = '/form';
		}

		if ('options' in $routeParams) {
			for (const v of $routeParams.options.split('/')) {
				const o = v.split('=');
				options[o[0]] = o.length === 2 ? o[1] : true;
			}
		}

		/** @type {boolean} */
		this.create = 'create' in options;

		/** @type {any} */
		this.options = {
			parent:   null,
			tree:     false,
			params:   {},
			tab:      search.tab,
			viewMode: 1,
		};

		for (const k of Object.keys(options)) {
			if (k === 'create' || k === 'edit') {
				this.options.readOnly = false;
			}
			else if (k) {
				this.options.params[k] = options[k];
			}
		}

		this.$scope.$watch('$ctrl.options.readOnly', (/** @type {boolean} */ readOnly) => {
			if (!this.create) {
				const search2 = $location.search();
				if (readOnly) {
					delete search2.edit;
				}
				else {
					search2.edit = true;
				}
				$location.search(search2);
			}
		});

		this.$scope.$on('$destroy', () => {
			if (!/^\/form\//.test($location.path())) {
				$location.search({});
			}
		});
	}

	cancel() {
		if (this.create) {
			this.$location.url(this.#fromView);
		}
		else {
			this.options.readOnly = false;
		}
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} itemKid
	 */
	submit(itemKid) {
		this.$location.url(`/form/${itemKid}`);
	}
}
